import { useState, useRef, useEffect } from 'react'

export function useCallbackRef<T = HTMLElement>() {
  return useState<T | null>(null)
}

export const useInterval = (callback: () => void, delay: number | null) => {
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (!delay) {
      return
    }
    const id = setInterval(() => savedCallback.current(), delay)
    return () => clearInterval(id)
  }, [delay])
}

export const usePolling = (callback: () => void, delay: number | null) => {
  useEffect(() => {
    callback()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps -- run once on mount

  useInterval(callback, delay)
}
